<div class="widget widget_recent_entries">
    <h2 class="widget-title">Recent Posts</h2>
    <ul>
        <li *ngFor="let list of List"><a href="javascript:void(0)">{{ list.title }}</a></li>
    </ul>
</div>